// ======================================================================
// File Name       : SuperUserSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, Button } from 'react-bootstrap';
import SelectBox from '../SelectBox';
import { convertNodeGroupToNodeString } from '../../utils/UserUtils';
import * as MessageTemplate from '../../constants/MessageTemplate';
import FormControlValidate from '../../components/FormControlValidate';
import { VALIDATE_TYPE } from '../../constants/index';
import CustomButton from '../button/CustomButton';
import * as ICON from '../../constants/IconConstants';
import CustomLink from '../button/CustomLink';
import * as Path from '../../constants/PathConstants';
import { WRITE } from '../../constants/index';

const SuperUserSearch = ({
  handleChange,
  openBatchDialog,
  showSelectGroupDlg,
  onSearchBtnClick,
  loginId,
  superuserName,
  enterpriseCd, //Step10.0.0
  enterpriseName,
  readOnlyFlag,
  canEditSuperuser,
  onLoginExportBtnClick,
  isBelongServiceGroup,
}) => (
  <div>
    <Form onSubmit={(e) => { e.preventDefault(); onSearchBtnClick(); }} className='form-horizontal'>
      <Col sm={12} className="margin-top-10">
        <Form.Group className="form-info" controlId="formHorizontalLoginID">
          <Col as={Form.Label} sm={3}>ログインID</Col>
          <Col sm={7}>
            <FormControlValidate
              type="text"
              name="loginId"
              label="ログインID"
              value={loginId}
              maxLength="256"
              // Step 10.0.0 START
              // Step 11.0.0 START
              validateType={VALIDATE_TYPE.LOGIN_ID_SU}
              // Step 11.0.0 END
              // Step 10.0.0 END
              onChange={handleChange}
              messageError={MessageTemplate.MSG_ID_INVALID}
              messageSuccess={MessageTemplate.MSG_ID_VALID}
            />
          </Col>
        </Form.Group>
        <Form.Group
          className="form-info"
          controlId="formHorizontalSuperUserName"
        >
          <Col as={Form.Label} sm={3}>SuperUser名</Col>
          <Col sm={7}>
            <FormControl
              type="text"
              maxLength="40"
              name="superuserName"
              value={superuserName}
              onChange={handleChange}
            />
          </Col>
        </Form.Group>
        {/* Step10.0.0 START */}
        <Form.Group
          className="form-info"
          controlId="formHorizontalEnterpriseCd" >
          <Col as={Form.Label} sm={3}>企業コード</Col>
          <Col sm={7}>
            <FormControl
              type="text"
              maxLength="40"
              name="enterpriseCd"
              value={enterpriseCd}
              onChange={handleChange}
            />
          </Col>
        </Form.Group>
        {/* Step10.0.0 END */}
        <Form.Group className="form-info" controlId="formHorizontalCompanyName">
          <Col as={Form.Label} sm={3}>企業名</Col>
          <Col sm={7}>
            <FormControl
              type="text"
              maxLength="256"
              name="enterpriseName"
              value={enterpriseName}
              onChange={handleChange}
            />
          </Col>
        </Form.Group>
      </Col>
      <Form.Group>
        <Col sm={12} className="text-center margin-top-10">
          <CustomButton
            btnStyle="btn btn-primary btn-96"
            type="submit"
            text="検索"
            iconClass="bi bi-search"
          />
        </Col>
      </Form.Group>
      <Form.Group>
        <Col sm={12} className="padding-left-right-clear">
          <Col sm={7} className="inline-flex">
            {!readOnlyFlag && canEditSuperuser && (
              <>
                <CustomLink
                  className="margin-right-7 btn-register margin-right-10"
                  to={Path.SUPERUSER_REGISTER}
                  text="SuperUser追加"
                  icon={ICON.REGIST}
                />
                <CustomLink
                  className="margin-right-7 btn-csv-import"
                  to={Path.SUPERUSER_IMPORT}
                  text="CSV一括投入"
                  icon={ICON.IMPORT}
                />
              </>
            )}
          </Col>
          <Col sm={5} className="display-flex justify-content-end float-end">
            {!isBelongServiceGroup && ( //Step10.0.0
              <CustomButton
                btnStyle="btn btn-export-csv margin-right-10"
                handleClick={onLoginExportBtnClick}
                iconClass="bi bi-download"
                text="ログイン履歴CSV出力"
              />
            )}
            <CustomButton
              btnStyle="btn-export-csv"
              handleClick={openBatchDialog.bind(
                this,
                MessageTemplate.BULK_EXPORT,
                null,
              )}
              text="一括出力"
              iconClass="bi bi-download"
            />
          </Col>
        </Col>
      </Form.Group>
    </Form>
  </div>
  );

export default SuperUserSearch;
